import actionTypes from '../constants/action-types';

const blurFocusedElement = (options = { preserveFocusedTextElement: false }) => ({
  type: actionTypes.BLUR_FOCUSED_ELEMENT,
  payload: {
    options,
  },
});

export default blurFocusedElement;
